// 站点品牌名取自当前域名 x.y.z 的中间段 y（如 admin.hermestoken.ai -> hermestoken）
// 非三段域名（localhost、IP 等）直接使用 hostname 本身
export function getBrandName(): string {
  if (typeof window === 'undefined') return '';
  const hostname = window.location.hostname;
  const parts = hostname.split('.');
  if (parts.length >= 3 && parts[1]) return parts[1];
  return hostname;
}

export function getSiteTitle(): string {
  const brand = getBrandName();
  return brand ? `${brand}-admin` : 'admin';
}
